<template>
  <div class="forget_wrap">
    <mt-header fixed title="找回密码">
      <router-link to="/" slot="left">
       <span class="back"></span>
      </router-link>
    </mt-header>
    <logo v-if="isLogo"></logo>
    <div v-if="isFirstStep">
     <div style="background: #ffffff;">
       <form class="forgetForm">
         <div class="errowShow" v-if="isShow">{{tishi}}</div>
         <div class="form-group">
           <label class="forget_label">手机号码</label>
           <input type="number" placeholder="输入手机号码" class="inputForm phone" v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)" v-on:focus="changePhone">
           <div style="position: absolute;right: .5rem;bottom: 0;"  @click.prevent="next" ref="getMsg">
             <span class="getCode" v-if="sendMsgDisabled">&nbsp;获取验证码</span>
             <span class="getCode" v-else>{{time + '秒后获取'}}</span>
           </div>
         </div>
         <div class="form-group">
           <label class="forget_label">验证码</label>
           <input type="text" placeholder="输入验证码" class="inputForm" oninput="if(value.length>6)value=value.slice(0,6)" v-model="code">
         </div>
       </form>
     </div>
     <div style="padding: .6rem .4rem"><mt-button type="primary" size="large" class="btn" @click="nextHandler">下一步</mt-button></div>
   </div>
    <div v-if="isSecondStep">
      <div style="background: #ffffff;">
         <form class="forgetForm">
           <div class="errowShow" v-if="isShow">{{tishi}}</div>
           <div class="form-group">
             <label class="forget_label">新密码</label>
             <input type="password" placeholder="输入新密码" class="inputForm" v-model="password" v-on:blur="changePassword" v-on:focus="focusPassword">
           </div>
           <div class="form-group">
             <label class="forget_label">确认密码</label>
             <input type="password" placeholder="再次输入新密码" class="inputForm" v-model="confirm_password" v-on:blur="changeConfirm_password" v-on:focus="focusConfirm_password">
           </div>
         </form>
       </div>
      <div style="padding: .6rem .4rem"><mt-button type="primary" size="large" class="btn" @click="nextDetermine">确定</mt-button></div>
    </div>
    <div class="wrap" v-if="isThirdStep">
      <div class="wrap_in">
        <div><img src="../../assets/images/success_big.png" alt=""></div>
        <p style="font-size: .4rem">密码设置成功</p>
        <p class="info">您可以通过用户名+密码或 手机号+密码</p>
        <p style="font-size: .28rem;color: #888888;">登陆法务云盘</p>
      </div>
      <router-link to="/login" style="padding: .6rem .4rem;display: block"><mt-button type="primary" size="large" class="btn">返回登录页面</mt-button></router-link>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
 import logo from '../../common/logo'
 import apis from '../../apis/index'
 import cloudApi from '../../apis/cloudStorageApi'
 export default {
   data () {
     return {
       time: 60,
       password: '',
       confirm_password: '',
       isFirstStep: true,
       isSecondStep: false,
       isThirdStep: false,
       isShow: false,
       isLogo: true,
       tishi: '',
       phone: '',
       code: '',
       userId: 'userId',
       sendMsgDisabled: true
     }
   },
   components: {
     logo
   },
   methods: {
     next: function () {
       var self = this
       var phone = self.phone.trim()
       var regMobile = /^1[3|4|5|7|8][0-9]{9}$/
       if (phone.length === 0) {
         self.isShow = true
         self.tishi = '手机号码不能为空'
         return false
       }
       if (phone.length !== 11 || !regMobile.test(phone)) {
         self.isShow = true
         self.tishi = '请正确填写您的手机号码'
         return false
       }
       apis.request(cloudApi.phoneValidate, {phone: phone}).then(function (response) {
         self.isShow = true
         self.tishi = '该手机号码尚未注册'
       }).catch(function () {
         apis.request(cloudApi.sendMsg, {type: 2, phone: phone}).then(function (response) {
           self.isShow = false
           var cur = self.$refs.getMsg
           self.sendMsgDisabled = false
           cur.disabled = true
           var interval = setInterval(function () {
             self.time--
             if ((self.time--) <= 0) {
               self.time = 60
               self.sendMsgDisabled = true
               cur.disabled = false
               clearInterval(interval)
             }
           }, 1000)
         }).catch(function (error) {
           self.isShow = true
           self.tishi = error.response.data.message
         })
       })
     },
     changePhone: function () {
       this.isShow = false
     },
     nextHandler: function () {
       // 调用校验验证码的接口
       var self = this
       let data = {phone: this.phone, smsCode: this.code}
       apis.request(cloudApi.psdIdentity, data).then(function (res) {
         self.isFirstStep = false
         self.isSecondStep = true
         self.isThirdStep = false
         self.userId = res.data.userId
       }).catch(function (error) {
         self.isShow = true
         self.tishi = error.response.data.message
       })
     },
     changePassword: function () {
       var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/
       var self = this
       var password = self.password
       if (password.trim() === '') {
         self.isShow = true
         self.tishi = '密码不能为空'
         return false
       }
       if (password.length < 6) {
         self.isShow = true
         self.tishi = '密码长度不能小于6个字符'
         return false
       }
       if (password.length > 16) {
         self.isShow = true
         self.tishi = '密码长度不能大于16个字符'
         return false
       }
       if (!reg.test(password)) {
         self.isShow = true
         self.tishi = '密码必须是6-16位字母、数字或符号两种以上组合'
         return false
       }
     },
     focusPassword: function () {
       this.isShow = false
     },
     changeConfirm_password: function () {
       var self = this
       var confirmpassword = self.confirm_password
       var password = self.password
       if (confirmpassword.trim() === '') {
         self.isShow = true
         self.tishi = '请输入密码'
         return false
       }
       if (confirmpassword !== password) {
         self.isShow = true
         self.tishi = '两次密码输入不一致'
         return false
       }
     },
     focusConfirm_password: function () {
       this.isShow = false
     },
     nextDetermine: function () {
       var self = this
       let data = {userId: self.userId, newPassword: self.confirm_password}
       // 接口请求
       apis.request(cloudApi.reset, data).then(function () {
         self.isFirstStep = false
         self.isSecondStep = false
         self.isThirdStep = true
         self.isLogo = false
       }).catch(function (error) {
       })
     }
   }
 }
</script>
<style scoped>
  html,body {
    height: 100%;
    overflow: hidden;
  }
.forget_wrap {
  height: 100%;
  padding-top: .88rem;
}
.mint-header{
    font-size:.36rem;
    color: #fff;
    font-weight: bolder;
    height: .88rem;
    /*line-height: 1rem;*/
    /*padding: .2rem 0;*/
    background-color: #E4393C;
}
.mint-header-title{
  font-weight: 500!important;
}
.form-group{
    background-color: #ffffff;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    height: .88rem;
    line-height: .88rem;
    box-sizing: border-box;
    overflow: hidden;
    /*padding: 0.05rem;*/
    padding: 0 .3rem;
  }
.inputForm{
  display: inline-block;
  font-size: .24rem;
  border: 0;
  border-radius: 0;
  outline: 0;
  color: #b2b2b2;
}
.getCode{
  padding-left: .2rem;
  float: right;
  line-height: .88rem;
  display: inline-block;
  font-size:.32rem;
  color: #E4393C;
  border-left: 1px solid #e5e5e5;
}
.forget_label{
  color: #000000;
  font-size: .24rem;
  width: 1.36rem;
  text-align: left;
  display: inline-block;
}
.errowShow{
  width: 100%;
  position: absolute;
  top:.88rem;
  bottom: 0;
  left: 0;
  right: 0;
  height: .7rem;
  background:#e64340;
  font-size: .3rem;
  color: white;
  text-align: center;
  line-height: .5rem;
  padding: .1rem 0;
}
.btn{
  /*margin: .4rem 0;*/
  height: .94rem;
  line-height: .94rem;
  font-size: .36rem;
  border-radius: .14rem;
}
.wrap_in{
  text-align: center;
}
.wrap_in>div>img{
  width: 1.86rem;
  padding: 2rem 0 .4rem 0;
}
.info{
  font-size: .28rem;
  color: #888888;
  font-family: '微软雅黑';
  margin-top: .2rem;
}
.back {
  width: .2rem;
  height: .3rem;
  /*margin-left: .3rem;*/
  background: url("../../assets/images/back.png") no-repeat;
  background-size: .2rem .3rem;
  display: inline-block;
  float: left;
  margin-top: .1rem;
  font-size: .28rem;
}
.mint-button--primary {
    background-color:#E4393C;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/forget.vue